import Button from "../../components/button";
import { Link } from "react-router-dom";
import sendIcon from "../../assets/icons/send.svg";
import Navbar from "../../components/navbar";
import Input from "../../components/input";

const ResetPassword = () => {
    return ( 
        <div className="bg-signInPattern bg-[length:24%]">
          <div className="bg-white/80 min-h-screen flex items-center pt-24 pb-16">
            {/* navbar */}
            <Navbar />
            <div className="px-4 md:px-12 grid grid-cols-1 lg:grid-cols-5 gap-4 w-full">
              <div className="bg-white rounded border lg:col-span-2 p-4 md:p-10">
               <p className="font-bold">Reset password</p>
               <p className="text-secondary leading-tight mt text-sm">Please set a new password for your account.</p>
               <form   className="mt-6 grid gap-4">
                  <Input
                   type={"email"}
                   label={"Email address"}
                   placeholder={"Muhammad@gmail.com"}
                  />
                  <Button buttonText={"Send reset link"} icon={sendIcon} otherStyles={"bg-black text-white"}/>
               </form>
               <p className="mt-6">Back to<Link to={"/sign-in"} className="underline text-brandGreen ps-1">sign in</Link></p>
              </div>
              <div className="lg:col-span-3 p-4 md:p-10">
                 <div className="h-full flex items-center">
                   <div className="text-center lg:text-start">
                     <p>“Those who spend their wealth in Allah’s cause are like grains of corn which produce seven ears, each bearing a hundred grains.”</p>
                     <p className="font-bold mt-2">Qur’an, 2:261</p>
                   </div>
                 </div>
              </div>
            </div>
          </div>
        </div>
     );
}
 
export default ResetPassword;